export type HostPlatform = "web" | "teams" | "desktop" | "mobile";

interface HostPlatformInfo {
  platform: HostPlatform;
  label: string;
}

declare global {
  interface Window {
    microsoftTeams?: unknown;
    __HEALTHOS_HOST__?: HostPlatform;
  }
}

function detect(): HostPlatform {
  if (typeof window === "undefined") return "web";
  if (window.__HEALTHOS_HOST__) return window.__HEALTHOS_HOST__;
  if (typeof window.microsoftTeams !== "undefined") return "teams";
  if (typeof window.parent !== "undefined" && window.parent !== window) {
    try {
      if (window.location.ancestorOrigins?.length) {
        for (let i = 0; i < window.location.ancestorOrigins.length; i++) {
          const origin = window.location.ancestorOrigins[i] ?? "";
          if (origin.includes("teams.microsoft.com") || origin.includes("teams.cloud.microsoft")) {
            return "teams";
          }
        }
      }
    } catch {
      /* cross-origin parent; fall through */
    }
  }
  const ua = navigator.userAgent || "";
  if (/Electron|HealthOS-Desktop/i.test(ua)) return "desktop";
  if (/iPhone|iPad|Android/i.test(ua)) return "mobile";
  return "web";
}

const LABELS: Record<HostPlatform, string> = {
  web: "this browser",
  teams: "Teams",
  desktop: "your desktop",
  mobile: "your phone",
};

export function useHostPlatform(): HostPlatformInfo {
  const platform = detect();
  return { platform, label: LABELS[platform] };
}
